import { Controller } from "@hotwired/stimulus"

// Mirrors a turbo-frame's navigation into the page URL. Attach to a
// <turbo-frame> whose src always points at the current page's path with
// different query params (e.g. filters). Without this, full-page refreshes
// (Turbo morph refreshes after an edit, native app refreshes) rebuild the
// page from the URL it was originally visited at and drop the frame's
// filter state.
export default class extends Controller {
  initialize() {
    this.sync = this.sync.bind(this)
  }

  connect() {
    this.element.addEventListener("turbo:frame-load", this.sync)
  }

  disconnect() {
    this.element.removeEventListener("turbo:frame-load", this.sync)
  }

  sync(event) {
    if (event.target !== this.element) return
    if (!this.element.src) return

    const url = new URL(this.element.src, window.location.href)
    if (url.pathname !== window.location.pathname) return

    history.replaceState(history.state, "", url)
  }
}
